const image = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
    <title>Combined Shape</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Coriolis" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Project/Add-Member/Existing" transform="translate(-262.000000, -337.000000)">
            <g id="Dropdown-List-Copy" transform="translate(33.000000, 337.000000)">
                <g id="Group" transform="translate(229.000000, 0.000000)">
                    <g id="Combined-Shape">
                        <g>
                            <path id="path" d="M8,0.707106781 L0.707106781,8 L8,15.2928932 L15.2928932,8 L8,0.707106781 Z" stroke="#A4AAB5" fill="#FFFFFF"></path>
                            <rect id="Rectangle" stroke="white" fill="white" x="0.5" y="8.5" width="15" height="7"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export default image;
